import { values } from 'lodash';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import * as analytics from '@eb/site-analytics';

import {
    getCanonicalSearchUrl,
    collections as collectionsDuck,
} from '@eb/destination-utils';

import MapPanel from '../components/MapPanel';

import { searchByBBoxOrPlace as searchByBBoxOrPlaceAction } from '../actions/search';

import {
    eventsCardInfoLookup,
    getSearchContent,
    getSearchSection,
} from '../utils';
import { hasEventResults } from '../utils/events';

import { GA_SEARCH_CATEGORY } from '../constants';
import { addSearchIdToGaAction } from '../utils/analytics';

const { trackEventFromState } = analytics;

const {
    actions: {
        addOrRemoveEventToCollection: addOrRemoveEventToCollectionAction,
        createCollection: createCollectionAction,
    },
    selectors: { getFormattedCollections },
} = collectionsDuck;

const _getEventSuggestions = (rawEvents, currencyFormat, section) => {
    const events = values(rawEvents);

    return eventsCardInfoLookup({
        bucketsContent: events,
        currencyFormat,
        section,
    });
};

export const _mapStateToProps = (state, ownProps) => {
    const section = getSearchSection(state.location.isOnline);
    const results = getSearchContent(
        state.content.entities,
        state.pagination,
        state.currencyFormat,
        section,
    );

    return {
        results,
        userCollections: state.app.featureFlags.enableUserCollections
            ? getFormattedCollections(state)
            : undefined,
        hasEventResults: hasEventResults(results),
        isAuthenticated: state.auth.isAuthenticated,
        shareOptions: state.share.options,
        isLoading: state.pagination.loading,
        eventSuggestions: _getEventSuggestions(
            state.suggestions.rawEvents,
            state.currencyFormat,
            section,
        ),
        allEventsUrl: getCanonicalSearchUrl({ slug: state.location.slug }),
        featureFlags: state.app.featureFlags,
        location: state.location,
        domain: state.app.domain,
        trackGAEvent: (action) =>
            trackEventFromState(state, addSearchIdToGaAction(action, state)),

        /* Data Passed to Connected Component From SearchBaseScreen */
        onSaveEvent: ownProps.onSaveEvent,
        onTrackEventClickInternal: ownProps.onTrackEventClickInternal,
    };
};

const _mapDispatchToProps = (dispatch, ownProps) => ({
    handleLocationSelect: (...args) =>
        dispatch(searchByBBoxOrPlaceAction(ownProps.history, ...args)),
    onAddOrRemoveEventToCollection: addOrRemoveEventToCollectionAction(
        GA_SEARCH_CATEGORY,
    ),
    onCreateCollection: createCollectionAction(GA_SEARCH_CATEGORY),
});

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(MapPanel),
);
